
import { useInteractionDoneTracking } from "@/mixins/tracking/interaction-done";
import { useClientStore } from "@/store/client";
import { useAuthStore } from "@/store/auth";
import { usePanierStore } from "@/store/panier";
import { useMagasinStore } from "@/store/magasin";

export const containerCreateAccountEmits = () => ([
  "accountCreated",
  "magasinSwitched"
])

export const useContainerCreateAccount = (context, popinConfirmationMagasinRef) => {

  const { trackEvent } = useInteractionDoneTracking()

  const magasinStore = useMagasinStore();
  const panierStore = usePanierStore();
  const authStore = useAuthStore();
  const clientStore = useClientStore();

  const magasins = ref([])
  const magasinsByCp = ref([])
  const currentCp = ref(null)
  const newMagasin = ref(null)
  const loginData = ref(null)
  const isLoading = ref(false)
  const error = ref(null)
  const creationCarteError = ref(false)
  const creationCarteDejaExistante = ref(false)

  const { id: magasinIdStore, isNational, name: magasinNameStore } = storeToRefs(magasinStore)

  const { create } = clientStore;
  const { login } = authStore;
  const { switchMagasin } = magasinStore;
  const { checkStatus } = panierStore;

  const magasinId = computed(() => {
    return isNational.value ? null : magasinIdStore.value;
  })

  const newMagasinName = computed(() => {
    if (loginData.value && loginData.value.id_magasin) {
      const magasin = magasins.value.find(
        mag => parseInt(mag.id) === parseInt(loginData.value.id_magasin)
      );
      if (magasin) {
        return magasin.attributes.magasin;
      }
    }
    return "";
  })

  const createAccount = async (data, needRedirect = true, carte = null) => {
    isLoading.value = true;
    try {
      await create(data);
      trackEvent({
        actionGA: trackingCodes.LABELGA.header,
        categoryGA: trackingCodes.CATEGORYGA.subscriptionOK,
        labelGA: ""
      });
      trackEvent({
        event: trackingCodes.EVENTS.signUp,
        pageType: trackingCodes.PAGETYPE.creationCompte,
        categoryGA: trackingCodes.CATEGORYGA.subscriptionOK,
        actionGA: trackingCodes.ACTIONGA.formulaireCreationCompte,
        email: data.optin_newsletter,
        choix_carte_inscription: carte 
        ? trackingCodes.CREATIONCOMPTE.creationCarte
         : data.num_carte_cora || data.num_carte_malin
          ? trackingCodes.CREATIONCOMPTE.carteExistante 
          : trackingCodes.CREATIONCOMPTE.pasCreationCarte,
        ...(carte && { sms: carte.acceptSms }),
        ...((carte || data.num_carte_malin) && { carteFidelite: trackingCodes.LOYALTYCARD.malin }),
        ...((data.num_carte_cora) && { carteFidelite: trackingCodes.LOYALTYCARD.cora })
      });
      loginData.value = data;
      if (needRedirect) {
        redirect();
      }
    } catch (err) {
      error.value = err;
      isLoading.value = false;
      let labelGA = "";
      const fields =
        typeof err === "object" && err.errors && typeof err.errors === "object" ? Object.keys(err.errors) : [];
      for (let i = 0; i < fields.length; i++) {
        labelGA += `${fields[i]}Error`;
      }
      trackEvent({
        actionGA: trackingCodes.LABELGA.header,
        categoryGA: trackingCodes.CATEGORYGA.inscriptionFail,
        labelGA: labelGA || trackingCodes.LABELGA.systemError
      });
      return Promise.reject(err);
    }
    return Promise.resolve();
  }
  const redirect = async () => {
    if (!isNational.value && parseInt(loginData.value.id_magasin) !== parseInt(magasinIdStore.value)) {
      isLoading.value = false;
      popinConfirmationMagasinRef.value.show();
    } else {
      await stayInCurrentMagasin();
    }
  }
  const stayInCurrentMagasin = async () => {
    try {
      isLoading.value = true;
      if (isNational.value) {
        await switchMagasin(loginData.value.id_magasin);
      } else {
        await checkStatus();
      }
    } catch (err) {
    } finally {
      isLoading.value = false;
      context.emit("accountCreated", {
        creationCarteError: creationCarteError.value,
        creationCarteDejaExistante: creationCarteDejaExistante.value
      });
    }
  }
  const changeMagasin = async () => {
    isLoading.value = true;
    try {
      await switchMagasin(loginData.value.id_magasin);
    } catch (err) {
    } finally {
      isLoading.value = false;
      context.emit("magasinSwitched", {
        creationCarteError: creationCarteError.value,
        creationCarteDejaExistante: creationCarteDejaExistante.value
      });
    }
  }


  return {
    magasins,
    magasinsByCp,
    currentCp,
    newMagasin,
    loginData,
    isLoading,
    error,
    creationCarteError,
    creationCarteDejaExistante,
    magasinIdStore,
    isNational,
    magasinNameStore,
    create,
    login,
    switchMagasin,
    checkStatus,
    magasinId,
    newMagasinName,
    createAccount,
    redirect,
    stayInCurrentMagasin,
    changeMagasin,
    trackEvent
  }

}